export const sharedContactConfirmationCode = "DUPLICATE_CONTACT_CONFIRMATION_REQUIRED";
export const sharedContactConfirmationEvent = "app:confirm-shared-contact";
export const sharedContactCancelledCode = "SHARED_CONTACT_CANCELLED";

export const run_with_shared_contact_confirmation = async request => {
    const response = await request(false);
    if (response?.data?.code !== sharedContactConfirmationCode) return response;

    const confirmed = await new Promise(resolve => {
        const detail = { ...response.data, resolve, handled: false };
        window.dispatchEvent(new CustomEvent(sharedContactConfirmationEvent, { detail }));
        if (!detail.handled) resolve(false);
    });
    return confirmed ? request(true) : { data: { code: sharedContactCancelledCode } };
};
